import { useCallback } from 'react';
import { store } from 'Utilities/store';
import { sharingCodeValidateService } from 'Services/libre_api';
const useCommercialApi = () => {
    const sharingCodeValidate = useCallback(async (code, yearOfBirth) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        try {
            await sharingCodeValidateService(code, yearOfBirth, user.id, osType, osVersion, app, appVersion);
            return {};
        }
        catch (err) {
            const error = err;
            const errorCode = error.response?.data.code;
            if (error.response?.headers['x-attempts-remaining']) {
                const attemptsRemaining = Number(error.response.headers['x-attempts-remaining']);
                if (attemptsRemaining === 0) {
                    return { errorCode, reachedMaxYobAttempts: true };
                }
            }
            return { errorCode };
        }
    }, []);
    return { sharingCodeValidate };
};
export default useCommercialApi;
